export default __webpack_public_path__ + "static/media/tas-table-delete.66efbfee.svg";